export default __webpack_public_path__ + "static/media/group.7bba2a91.png";